import { activeInstitutionId } from './saasSession';

export const LICENSE_FEATURES = Object.freeze({
  REPORTS: 'reports',
  IOT: 'iot',
  API_CONNECTIONS: 'api_connections',
  FORESIGHT: 'foresight',
  SCENARIO_MARKETPLACE: 'scenario_marketplace',
  PARTNERS: 'partners',
});

export const LICENSE_FEATURE_LABELS = Object.freeze({
  [LICENSE_FEATURES.REPORTS]: 'Reports',
  [LICENSE_FEATURES.IOT]: 'IoT',
  [LICENSE_FEATURES.API_CONNECTIONS]: 'API Connections',
  [LICENSE_FEATURES.FORESIGHT]: 'ForeSight',
  [LICENSE_FEATURES.SCENARIO_MARKETPLACE]: 'Scenario Marketplace',
  [LICENSE_FEATURES.PARTNERS]: 'Partners',
});

const FEATURE_ROUTES = Object.freeze([
  { pattern: /^\/reports(?:\/|$)/, feature: LICENSE_FEATURES.REPORTS },
  { pattern: /^\/iot-(?:sensors|devices)(?:\/|$)/, feature: LICENSE_FEATURES.IOT },
  { pattern: /^\/api-connections(?:\/|$)/, feature: LICENSE_FEATURES.API_CONNECTIONS },
  { pattern: /^\/foresight(?:\/|$)/, feature: LICENSE_FEATURES.FORESIGHT },
  { pattern: /^\/scenario-marketplace(?:\/|$)/, feature: LICENSE_FEATURES.SCENARIO_MARKETPLACE },
]);

export const featureEntitlementsForUser = (user) => {
  const entitlements = user?.saas_context?.feature_entitlements;
  return entitlements && typeof entitlements === 'object' && !Array.isArray(entitlements)
    ? entitlements
    : {};
};

/**
 * Entitlements apply only while the session is scoped to an institution.
 * Missing keys remain enabled for compatibility with pre-license tenants.
 */
export const isFeatureEnabled = (user, feature) => {
  if (!feature || !activeInstitutionId(user)) return true;
  const entitlements = featureEntitlementsForUser(user);
  if (
    feature === LICENSE_FEATURES.FORESIGHT
    && entitlements[LICENSE_FEATURES.API_CONNECTIONS] === false
  ) {
    return false;
  }
  return entitlements[feature] !== false;
};

export const areForesightArtifactsEnabled = (user) => (
  isFeatureEnabled(user, LICENSE_FEATURES.API_CONNECTIONS)
  && isFeatureEnabled(user, LICENSE_FEATURES.FORESIGHT)
);

export const FORESIGHT_NOTIFICATION_TYPES = Object.freeze([
  'EARLY_WARNING',
  'EARLY_WARNING_DISPATCH',
]);

export const isLicensedNotification = (user, notification) => (
  !FORESIGHT_NOTIFICATION_TYPES.includes(String(notification?.type || ''))
  || areForesightArtifactsEnabled(user)
);

export const licensedFeatureForWebPath = (pathname) => {
  const normalizedPath = String(pathname || '/').split(/[?#]/, 1)[0] || '/';
  return FEATURE_ROUTES.find(({ pattern }) => pattern.test(normalizedPath))?.feature || null;
};

export const disabledFeatureForWebPath = (user, pathname) => {
  const feature = licensedFeatureForWebPath(pathname);
  return feature && !isFeatureEnabled(user, feature) ? feature : null;
};

export const labelForLicenseFeature = (feature) => (
  LICENSE_FEATURE_LABELS[feature]
  || String(feature || '').replace(/_/g, ' ')
);
